import React from 'react';
import { translate } from '../Services/translation';
import InfoBox from './InfoBox';
import clsx from 'clsx';
import { InfoBoxPlacements } from '../constants';

const TierPrices = (props) => {
  const {
    tierPrices,
    currency,
    packageSize
  } = props;
  const currentCulture = window.__litium.currentCulture;

  return (
    <>
      <div className="tier-prices__description">
        {translate('product.tier-price.description')}
      </div>
      <div className="tier-prices">
        <div className="tier-prices__row">
          <div>{translate('product.tier-price.quantity')}</div>
          <div>{translate('product.tier-price.price-per-piece')}</div>
        </div>
        <div className="tier-prices__prices">
        {tierPrices.map((tier, idx) => {
          if (idx === 0) {
            tier.minimumQuantity = packageSize;
          }; 
          return (
            <div className="tier-prices__row" key={`tier-row-${idx}`}>
              <div>{tier.minimumQuantity}+</div>
              <div>
                {tier.price.toLocaleString(currentCulture, {
                  style: 'currency',
                  currency: currency.id,
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </div>
            </div>
          );
        })}
        </div>
      </div>
    </>
  );
};

const PriceDetails = (props) => {
  const {
    formattedCampaignPrice,
    formattedPrice,
    pricePerPiecesText,
    hideTierPrice,
    disableTierPriceTooltip,
    tierPrices,
    currency,
    packageSize,
  } = props;

  return (
    <>
      {formattedCampaignPrice && (
        <div className="price__old-price">{formattedPrice}</div>
      )}
      <div className="price__price-and-tier-wrapper">
        <div className="price__price-and-package-wrapper">
          <div
            className={clsx(
              'price',
              formattedCampaignPrice ? 'price--campaign' : ''
            )}
          >
            {formattedCampaignPrice
              ? formattedCampaignPrice
              : formattedPrice}{' '}
            <span className="price__package-size">
              {pricePerPiecesText}
            </span>
          </div>
        </div>
        {!hideTierPrice &&  !disableTierPriceTooltip && tierPrices && !!tierPrices.length && tierPrices.length > 1 && currency && (
          <InfoBox
            label={translate('product.tier-price')}
            id="price-box"
            placement={InfoBoxPlacements.TopEnd}
          >
            <TierPrices 
              tierPrices={tierPrices}
              currency={currency}
              packageSize={packageSize} />
          </InfoBox>
        )}
      </div>
    </>);
};

const Price = ({
  price,
  disableTierPriceTooltip,
  packageSize,
  hideTierPrice,
  showForQuantity = 0,
  currency,
  className,
  priceOnRequestLabel = 'product.price.on-request',
}) => {
  const {
    formattedPrice,
    formattedCampaignPrice,
    tierPrices,
    hasPrice,
  } = price;
  const currentCulture = window.__litium.currentCulture;
  const matchedTierPrice = showForQuantity > 0 && tierPrices && tierPrices.length > 0
    ? tierPrices.find((tier, i) =>
      i !== 0 &&
      tier.minimumQuantity <= showForQuantity &&
      (!tier.nextMinimumQuantity || tier.nextMinimumQuantity > showForQuantity))
    : undefined;
  // Guard against currency being undefined — on some channels (notably Apex without a
  // ChannelModel currency in scope) it's null, and accessing currency.id below throws,
  // crashing the whole product card. Fall back to the pre-formatted campaign price.
  const displayCampaignPrice = matchedTierPrice && currency?.id
    ? matchedTierPrice.price.toLocaleString(currentCulture, {
        style: 'currency',
        currency: currency.id,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : formattedCampaignPrice;

  return (
    <div className={clsx('price__wrapper', className)}>
      {!hasPrice ? (
        <div className="price price__on-request">{translate(priceOnRequestLabel)}</div>
      ) : (
        <PriceDetails 
          formattedCampaignPrice={displayCampaignPrice}
          formattedPrice={formattedPrice}
          pricePerPiecesText={`/ 100 ${translate('product.pieces')}`}
          hideTierPrice={hideTierPrice}
          disableTierPriceTooltip={disableTierPriceTooltip}
          tierPrices={tierPrices}
          currency={currency}
          packageSize={packageSize} />
      )}
    </div>
  );
};

export default Price;
